import { APIRouteMap } from '@core/models/api';
import { environment } from '@environment';

export const INTERCEPTOR_CONFIG = {
  jwtInterceptor: {
    skipUrls: [
      APIRouteMap.AUTH,
      APIRouteMap.CONTENT_GETTRANSLATES,
      APIRouteMap.CONTENT_GETLANGUAGES,
      APIRouteMap.USER_RECOVERYPASSWORDCOMPLETE,
      APIRouteMap.USER_RECOVERYPASSWORDINIT,
      APIRouteMap.USER_SETUSERPASSWORD,

      // Добавляем только если enabled = true
      ...(environment.mockServiceWorker.enabled
        ? environment.mockServiceWorker.endpoints.map((x) => x.url)
        : []),
    ],
  },
  langInterceptor: {
    skipUrls: [APIRouteMap.CONTENT_GETLANGUAGES],
  },
};
